import $ from 'jquery';
import {View} from 'backbone';
import {isEmpty} from 'lodash';

import {getFetch} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import navItemTemplate from 'templates/sites/navItemTemplate.hbs';
import navManagerTemplate from 'templates/sites/navManagerTemplate.hbs';
import NavManagerModel from 'models/properties/navManagerModel';
import * as analytics from 'analytics/property';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';
import {messageHandler} from '@sinclair-digital/stl-common/src/sinclair/sinclair.uiTools';

const selectors = {
    name: '.js-sda-NavItem-name',
    url: '.js-sda-NavItem-url',
    info: '.js-sda-NavItem-info',
    errorMessage: '.js-sda-NavItem-status-error',
    primaryColor: '.js-sda-NavItem-primaryColor',
    secondaryColor: '.js-sda-NavItem-secondaryColor',
    colorWrapper: '.js-sda-NavItem-colorWrapper',
    swatch: '.js-sda-NavItem-colorSwatch',
};

export const NavManagerView = View.extend({
    el: '#admin-main',
    navId: 'admin-properties-tab',
    sdaPageTitle: 'navigation manager',
    template: navManagerTemplate,
    parentView: undefined,
    domain: undefined,
    allSites: undefined,
    events: {
        'click .nav-manager-toggle-subnav': '_toggleSubNavVisibility',
        'click #nav-manager-cancel-btn': '_closeNavManager',
        'click #nav-manager-save-btn': '_saveNavManager',
        'focusout input.sda-main-panel-title': '_focusOutRequiredFields',
        'click .sda-btn-right-tab': '_toggleNavGroups',
        'click .nav-manager-add-nav': '_addNavItem',
        'click .nav-manager-add-subnav': '_addSubNavItem',
        'click .nav-manager-delete-item': '_deleteNavItem',
        [`keyup ${selectors.colorWrapper}`]: 'updateSwatch',
        [`keyup input.sda-input-text.js-sda-NavItem-url`]: 'updateHints',
        'focusout input.sda-input-text.js-sda-NavItem-url': 'hideHints',
    },
    initialize(opts) {
        const that = this;
        bindAllMethods(this);
        that.render(opts);
    },
    render(opts) {
        const that = this;
        const fetchOpts = {
            type: 'GET',
            error() {
                that.routeChanger('property', 'error', 'Error retrieving navigation');
            },
        };

        if (opts.parentView) {
            that.parentView = opts.parentView;
            that.domain = opts.parentView.model.get('parentSite').url;
        }

        if (opts.el) {
            that.setElement(opts.el);
        }

        $(that.el)
            .html(that.template())
            .sdaInitWidgets();

        if (that.navManagerModel) {
            that.navManagerModel.clear().set(that.navManagerModel.defaults);
        } else {
            that.navManagerModel = new NavManagerModel({
                id: opts.id,
            });
        }

        that.allSites = that.allSites || that.navManagerModel
            .getSbgModules()
            ._appContext.userModel
            .get('availableTargets')
            .reduce(
                (acc, target) => {
                    acc.add(`http://${target.get('site').get('url')}`);
                    return acc;
                },
                new Set()
            );

        if (opts.id) {
            fetchOpts.model = that.navManagerModel;
            that.navManagerModel.url = '/api/facade_navigation_site/' + opts.id;
            that.navManagerModel.fetch(getFetch(fetchOpts)).then(that._successHandler);
        } else {
            that.routeChanger('property', 'error', 'Error retrieving navigation');

            return false;
        }

        $('#sda-nav-manager-fly-over').open();

        analytics.viewNavigation(opts.id);

        return that;
    },
    _successHandler() {
        this.$el.html(this.template(this.navManagerModel.attributes)).sdaInitWidgets();
        this.$('.sda-nav-manager-list, .sda-subnav-manager-list').sortable({
            handle: '.sda-item-handle',
        });
    },
    updateSwatch(e) {
        this.$(e.currentTarget)
            .find(selectors.swatch)
            .attr('style', `background-color: ${this.$(e.target).val()}`);
    },
    updateHints(e) {
        let text = e.target.value.toLowerCase();
        const container = this.$(e.currentTarget).parent();
        container.parent().parent()
            .find('.sda-NavItem-status i')
            .remove();
        container.parent().parent()
            .find('.sda-NavItem-message div')
            .remove();
        $('.autocomplete-items').remove();
        if (text.length > 2) {
            const input = this.$(e.currentTarget);
            const autocomleteList = document.createElement('div');
            autocomleteList.setAttribute('class', 'autocomplete-items');
            container.append(autocomleteList);
            const hints = this._getHint(text, 5);
            hints.forEach((hint, index) => {
                const autocompleteItem = document.createElement('div');
                autocompleteItem.setAttribute('class', 'autocomplete-item');
                //*in case if user typed something like https://{domain} hint gonna make bold only "domain" since hints don't show https prefix.
                if (`https://${this.domain}`.includes(text)) {
                    text = text.slice(text.indexOf(this.domain[0]), text.length);
                }
                //*making entered text bold in hint
                autocompleteItem.innerHTML = hint.slice(0, hint.indexOf(text));
                autocompleteItem.innerHTML += `<strong>${hint.slice(hint.indexOf(text), hint.indexOf(text) + text.length)}</strong>`;
                autocompleteItem.innerHTML += hint.slice(hint.indexOf(text) + text.length, hint.length);
                /*insert a input field that will hold the current array item's value:*/
                autocompleteItem.innerHTML += `<input id='hint-${index}' type='hidden' value='${hint}'>`;
                /*execute a function when someone clicks on the item value (DIV element):*/
                autocompleteItem.addEventListener('click', function () {
                    /*insert the value for the autocomplete text field:*/
                    input.val($(`input#hint-${index}`).val());
                    /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                    $('.autocomplete-items').remove();
                });
                autocomleteList.append(autocompleteItem);
            });
        }
    },
    _toggleSubNavVisibility(e) {
        const $caller = $(e.target);
        const $item = $caller.closest('li');

        if ($item.hasClass('sda-nav-item-open')) {
            $item.removeClass('sda-nav-item-open');
            $item.find('.sda-nav-item-open').removeClass('sda-nav-item-open');
        } else {
            $item.addClass('sda-nav-item-open');
        }
    },
    _closeNavManager() {
        const that = this;

        $(that.el).close();
        $('.sda-nav-item-open').removeClass('sda-nav-item-open');
    },
    _isNavsValid(that) {
        let validForm = true;

        $('.sda-nav-manager-list').sdaRemoveError();
        $('.sda-nav-manager-list').each(function (navListIndex) {
            const $this = $(this);
            let isListValid = true;

            [selectors.name, selectors.url].forEach(selector => {
                $this.find(selector).each(function () {
                    const $input = $(this);

                    if (!$input.val()) {
                        $input.sdaError('Required field');
                        that.$('#nav-manager-tabs .sda-btn-right-tab:eq(' + navListIndex + ')').addClass('sda-right-tab-errors');
                        validForm = false;
                        isListValid = false;
                    }
                });
            });

            $this.find('.sda-NavItem-status').each(function () {
                const $info = $(this);
                const $parent = $info.parent();
                if ($info.children().length === 0) {
                    $parent.find('.sda-NavItem-apply-btn button').click();
                }

                if ($parent.find('.sda-NavItem-message').children().length > 0) {
                    that.$('#nav-manager-tabs .sda-btn-right-tab:eq(' + navListIndex + ')').addClass('sda-right-tab-errors');
                    validForm = false;
                    isListValid = false;
                }
            });

            if (!isListValid) {
                $this.find('li').addClass('sda-nav-item-open');
            }
        });
        return validForm;
    },
    getNavErrors(links) {
        let errors = 0;
        links.forEach(link => {
            if (link.error) errors++;
            if (link?.children?.length) errors += this.getNavErrors(link.children);
        });
        return errors;
    },
    convertHttp() {
        const that = this;
        $(`.sda-nav-manager-list ${selectors.url}`).each(function () {
            const urlField = $(this);
            const currentValue = urlField.val();
            if (that.allSites.has(currentValue.split('/').slice(0, 3)
                .join('/'))) {
                urlField.val(currentValue.replace('http://', 'https://'));
            }
        });
    },
    _saveNavManager() {
        setTimeout(() => {
            this.convertHttp();
            const that = this;
            let validForm = true;
            const modelUpdateTuples = [
                ['#nav-main-list', 'setMainNav'],
                ['#nav-quicklinks-list', 'setQuickNav'],
                ['#nav-station-info-list', 'setInfoNav'],
                ['#nav-mobile-list', 'setMobileNav'],
            ];
            const putOpts = {
                type: 'PUT',
            };

            that.$('#nav-manager-tabs .sda-btn-right-tab').removeClass('sda-right-tab-errors');

            $('.sda-main-panel-title').sdaRemoveError();
            $('.sda-main-panel-group').each(function (i) {
                const $this = $(this);
                const $titleInput = $this.find('.sda-main-panel-title');

                if (!$titleInput.val()) {
                    $titleInput.sdaError('Required field');
                    that.$('#nav-manager-tabs .sda-btn-right-tab:eq(' + i + ')').addClass('sda-right-tab-errors');
                    validForm = false;
                } else {
                    modelUpdateTuples[i].push($titleInput.val().toString());
                }
            });

            if (validForm && this._isNavsValid(that)) {
                modelUpdateTuples.forEach(tuple => {
                    const listId = tuple[0];
                    const setMethod = this.navManagerModel[tuple[1]];
                    const name = tuple[2];

                    if (!isEmpty(name)) {
                        setMethod(name, this._recurseNavItems(this.$(listId)));
                    }
                });

                analytics.saveNavigation(this.navManagerModel.get('id'));
                this.navManagerModel.save({}, getFetch(putOpts)).then((res) => {
                    const data = res.data ? res?.data[0] : res[0];
                    const errors = (this.getNavErrors(data.navMobile.children) + this.getNavErrors(data.navMain.children) +
                        this.getNavErrors(data.navInfo.children) + this.getNavErrors(data.navQuick.children));
                    const selecteId = $('#nav-manager-tabs .sda-btn-selected').attr('id');
                    this.$el.html(this.template(data));
                    this._isNavsValid(that);
                    $('.sda-main-panel-open').removeClass('sda-main-panel-open');
                    $('#nav-manager-tabs .sda-btn-selected').removeClass('sda-btn-selected');
                    $(`#${selecteId}`).addClass('sda-btn-selected');
                    $(`#${selecteId}-group`).addClass('sda-main-panel-open');
                    if (errors > 0) {
                        messageHandler('error', `There ${errors === 1 ? 'is' : 'are'} ${errors} error${errors === 1 ? '' : 's'} on the page`);
                    } else {
                        messageHandler('success', 'Navigation updated');
                        this._closeNavManager();
                    }
                });
            }
        }, 200);
    },
    _focusOutRequiredFields(e) {
        const $caller = $(e.target);
        const navSet = $caller.closest('.sda-main-panel-group').attr('data-nav-set');

        if ($caller.val()) {
            $caller.sdaRemoveError();
            $('.sda-btn-right-tab[data-nav-set="' + navSet + '"]')
                .removeClass('sda-right-tab-errors')
                .text($caller.val());
        } else {
            $caller.sdaError('Required field');
            $('.sda-btn-right-tab[data-nav-set="' + navSet + '"]').text('*no name*');
        }
    },
    getAllHints() {
        const that = this;
        return this.navManagerModel.getSbgModules()._appContext.userModel.get('availableTargets').reduce(
            (acc, target) => {
                if (target.get('site').get('url') === this.domain) {
                    const fqp = this.navManagerModel.getFQPFromSections(target.get('sections').toJSON());
                    return acc.concat(fqp);
                }
                return acc;
            },
            []
        )
            .filter(el => el !== `${that.domain}/news`);
    },
    _getHint(text, limit = 10) {
        // domain is the domain from the parent site of the site-tree for the siteTreeView
        const globalHints = this.getAllHints();
        const domainRegexp = new RegExp(`${this.domain}`, '');
        const betterHints = globalHints
            .map(el => el.replace(domainRegexp, ''))
            .filter(hint => hint.includes(text))
            .concat(`https://${this.domain}`.includes(text) ? globalHints : [])
            .slice(0, limit);
        return betterHints.length > 0 ? betterHints : globalHints.filter(hint => hint.includes(text.replace('https://', ''))).slice(0, limit);
    },
    isUrlValid(url) {
        const text = url;
        const allHints = [...this.getAllHints(), `${this.domain}/`, '#', `${this.domain}`];
        const domainRegexp = new RegExp(`${this.domain}`, '');
        const relativeHints = allHints.map(el => el.replace(domainRegexp, ''));
        if (text.startsWith('#') || text.startsWith('/') || text.startsWith(this.domain)) return allHints.concat(relativeHints).includes(text.split('#')[0]);
        const validUrlPattern = new RegExp(
            '^(https?:\\/\\/)?' + // validate protocol
                '(' +
                '(' +
                '(' +
                '[a-z\\d]' + // a-z or a decimal
                '([a-z\\d-]*[a-z\\d])*' + //  followed by any number of a-z or decimal or dash (-) followed by a a-z or number
                ')' + // close out the grouping
                '\\.' + // followed by a literal dot (.)
                ')+' + // one or more of these
                '[a-z]{2,}' + // ending with 2 or letters -- this is the TLD (Top Level Domain) validation
                '|' + // OR
                '((\\d{1,3}\\.){3}\\d{1,3})' + // ipv4 address validation
                ')' + // ending of the domain/host portion
                '(\\:\\d+)?' + // optional port number
                '(\\/[-a-z\\d%_.~+]*)*' + // validate optional path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate optional query string
                '(\\#[-a-z\\d_]*)?' + // validate optional hash
                '$', // end
            'i'// match ignoring case
        );
        return Boolean(validUrlPattern.test(text));
    },
    applyLink(row) {
        const url = row.find('input.sda-input-text.js-sda-NavItem-url').val()
            ?.replace(/,/gi, '%2C');
        row.find('i').remove();
        row.find('.js-sda-NavItem-status-error').remove();
        row.find('.tooltiptext').remove();
        if (!url) {
            return row.find('input.sda-input-text.js-sda-NavItem-url').sdaError('Required field');
        }
        if (this.isUrlValid(url)) {
            row.find('input.sda-input-text.js-sda-NavItem-url').val(url);
            const icon = document.createElement('i');
            const tooltip = document.createElement('span');
            icon.setAttribute('class', 'fa fa-check-circle-o');
            tooltip.setAttribute('class', 'tooltiptext');
            tooltip.innerHTML = 'Valid';
            row.find('.sda-NavItem-status').append(icon);
            return row.find('.sda-NavItem-status').append(tooltip);
        } else {
            const icon = document.createElement('i');
            const errorText = document.createElement('div');
            errorText.innerText = 'Invalid path';
            icon.setAttribute('class', 'fa fa-exclamation-circle sda-status-error');
            errorText.setAttribute('class', 'sda-status-error js-sda-NavItem-status-error');
            row.find('.sda-NavItem-status').append(icon);
            return row.find('.sda-NavItem-message').append(errorText);
        }
    },
    hideHints(e) {
        const row = $(e.target.closest('.sda-NavItem-inputsWrapper'));
        setTimeout(() => {
            $('.autocomplete-items').remove();
            this.applyLink(row);
        }, 150);
    },
    _recurseNavItems($list) {
        const that = this;
        const arr = [];

        $list.find('> li').each(function (index) {
            const $this = $(this);
            const $name = $this.find(selectors.name).first();
            const $url = $this.find(selectors.url).first();
            const $subnav = $this.find('> .sda-nav-list');
            const info = JSON.parse(
                $this
                    .find(selectors.info)
                    .first()
                    .text(),
            ) || {
                primaryColor: '',
                secondaryColor: '',
            };
            const item = {
                uuid: null,
                displayName: null,
                nodeName: null,
                nodePathUrl: null,
                nodePropertyUuid: null,
                order: null,
                children: [],
            };
            const colors = {
                primaryColor: $this.find(selectors.primaryColor).val(),
                secondaryColor: $this.find(selectors.secondaryColor).val(),
            };

            item.uuid = $name.attr('id');
            item.displayName = item.nodeName = $name.val();
            item.nodePathUrl = $url.val();
            item.order = index + 1;
            item.info = Object.assign(info, colors);

            if ($subnav.length > 0) {
                item.children = that._recurseNavItems($subnav);
            }

            arr.push(item);
        });

        return arr;
    },
    _toggleNavGroups(e) {
        const $currentTab = $('#nav-manager-tabs .sda-btn-selected');
        const $nextTab = $(e.target);
        const tabSelection = $nextTab.attr('id');
        const $currentGroup = $('.sda-main-panel-open');
        const $nextGroup = $('#' + tabSelection + '-group');

        $currentGroup.removeClass('sda-main-panel-open');
        $nextGroup.addClass('sda-main-panel-open');

        $currentTab.removeClass('sda-btn-selected');
        $nextTab.addClass('sda-btn-selected');
    },
    _addNavItem(e) {
        const $navList = $(e.target)
            .closest('.sda-main-panel-body-fixed')
            .children('.sda-nav-list');
        const $child = $('<li>').append(navItemTemplate({info: {}}));
        $child.find('.sda-NavItem-status i').remove();
        $child.find('.sda-NavItem-status span').remove();
        $navList
            .append($child)
            .find('.nav-item-name .sda-input-text')
            .focus();

        $('.sda-nav-manager-list, .sda-subnav-manager-list').sortable({
            handle: '.sda-item-handle',
        });
    },
    _addSubNavItem(e) {
        const $caller = $(e.target);
        const $article = $(e.target).closest('article');
        const $item = $caller.closest('li');
        const $child = $('<li>').append(navItemTemplate({info: {}}));
        $child.find('.sda-NavItem-status i').remove();
        $child.find('.sda-NavItem-status span').remove();
        let $navList = $item.children('.sda-nav-list');

        if ($navList.length > 0) {
            $item.addClass('sda-nav-item-open');
            $navList
                .append($child)
                .find('.nav-item-name .sda-input-text')
                .focus();
        } else {
            $article.prepend('<a class="nav-manager-toggle-subnav fa-angle-down"></a>');
            $navList = $('<ul class="sda-nav-list sda-subnav-manager-list">').append($child);

            $item
                .addClass('sda-nav-item-open')
                .append($navList)
                .children('.sda-nav-list')
                .find('.nav-item-name .sda-input-text')
                .focus();
        }

        $('.sda-nav-manager-list, .sda-subnav-manager-list').sortable({
            handle: '.sda-item-handle',
        });
    },
    _deleteNavItem(e) {
        const $caller = $(e.target);
        const $item = $caller.closest('li');

        $item.remove();
    },
});

export default NavManagerView;
